import { hasModule } from "csi/_base/modules";
import reflection from "csi/reflection";
import StoreValuePairsConstructor from "csi/store/ValuePairs";
import xml from "csi/xml";
import Query from "csi/xml/Query";

/** return roles required to work with processes */
export function getProcessRoles(): string[] {
	return ["Workflow Viewer", "Workflow Administrator"];
}

/** return node types/subtypes for which processes are defined */
export async function getProcessTypes(): Promise<string[]> {
	if (!hasModule("Camunda")) {
		return [];
	}

	const store = new StoreValuePairsConstructor({
		filterQuery: new Query().Type("CamundaProcessDefinitionRevision")
			.Attr("State", xml.OP_EQUALS, reflection.REVISION_APPROVED),
		requestParameters: {
			"Qry.Value.Attr": "PrimaryType",
			"Qry.Value.Attr2": xml.ATTR_NAME,
			"Qry.Value.Path": reflection.PATH_PARENT,
			"Qry.Value.Path2": xml.path(reflection.PATH_PARENT, "PrimarySubtype"),
		},
	});

	const { value1Property, value2Property } = store;
	const results = await store.asyncQuery();

	return results.map((item) => {
		const type = item[value1Property];
		const subtype = item[value2Property];
		return xml.combineNodeTypeAndSubtype(type, subtype);
	});
}
